import { intl } from '../../utils/intl';
const t = (id) => intl.formatMessage({ id });

/*List of all fields and options available in this schema - same applies for the other schema in other BasicInfo areas
  Section
    field_in_a_format_like_this
      REQUIRED ITEMS
      label: - a set value, or a text value set elesewhere - we have everything in en/es so this should almost always be in the lang files
      type: - available options are:boolean,text,number,measurement,select(isMulti)-kind of field, makes a lot of differences elsewhere
      OPTIONAL
      placeholder: - light colored text that appears in the field prior to the user entering anything - does not satify the requirement to publish                  
      validation: - any characters you restrict from being put in that field
      width: - is a percentage - I believe this is on the admin side for the width of the screen
      required: - boolean, default is true if you do not include
      softRequired: - boolean, red text but does not stop the publication
      enabled: - boolean, default is true if you do not include
      visible: - boolean, default is true if you do not include
      photosEnabled: - boolean, default is true if you do not include
      surveyed: - boolean, not surveyed reason
      isMulti - boolean, requires options to choose from
      options: - the things that the user can choose from [
        { label: 'Left', value: 'Left' }, label that is shown to user and the value that goes into our DB for it
      viewModeRenderOptions: {
        append: - value (set or from elsewhere) that is appended to the end of the field value
        paren: - an append, but inside of parenthesis (can be a set value or a value set elsewhere)
        options: - only one I know of is { fullLength: true } which is for the published side
*/

const id360LocationOptions = [
  { label: 'Front Exterior', value: 'Front Exterior' },
  { label: 'Rear Exterior', value: 'Rear Exterior' },
  { label: 'Left Exterior', value: 'Left Exterior' },
  { label: 'Right Exterior', value: 'Right Exterior' },
  { label: 'Electrical Room', value: 'Electrical Room' },
  { label: 'Meter Room', value: 'Meter Room' },
  { label: 'Riser Room', value: 'Riser Room' },
  { label: 'Sprinkler Room', value: 'Sprinkler Room' },
  { label: 'Utility Room', value: 'Utility Room' },
  { label: 'Restroom', value: 'Restroom' },
  { label: 'Restroom Ceiling', value: 'Restroom Ceiling' },
  { label: 'Ceiling', value: 'Ceiling' },
  { label: 'Roof', value: 'Roof' },
  { label: 'Rear Wall', value: 'Rear Wall' },
  { label: 'Mezzanine', value: 'Mezzanine' },
  { label: 'Break Room', value: 'Break Room' },
  { label: 'Closet', value: 'Closet' },
  { label: 'Fitting Room', value: 'Fitting Room' },
  { label: 'Hallway', value: 'Hallway' },
  { label: 'Kitchen', value: 'Kitchen' },
  { label: 'Kitchenette', value: 'Kitchenette' },
  { label: 'Maintenance Room', value: 'Maintenance Room' },
  { label: 'Mechanical Room', value: 'Mechanical Room' },
  { label: 'Open Space', value: 'Open Space' },
  { label: 'Patio', value: 'Patio' },
  { label: 'Private Room', value: 'Private Room' },
  { label: 'Office', value: 'Office' },
  { label: 'Recieving', value: 'Recieving' },
  { label: 'Reception', value: 'Reception' },
  { label: 'Sauna', value: 'Sauna' },
  { label: 'Server Room', value: 'Server Room' },
  { label: 'Shower Room', value: 'Shower Room' },
  { label: 'Stairway', value: 'Stairway' },
  { label: 'Storage Room', value: 'Storage Room' },
  { label: 'Vault', value: 'Vault' },
  { label: 'Vestibule', value: 'Vestibule' },
  { label: 'Wash Room', value: 'Wash Room' },
  { label: 'Warehouse', value: 'Warehouse' },
  { label: 'Inaccessible', value: 'Inaccessible' },
  { label: 'Other', value: 'Other' },
  { label: 'NA', value: 'NA' }
]

const rpmLocationOptions = [
  { label: 'Front Exterior', value: 'Front Exterior' },
  { label: 'Rear Exterior', value: 'Rear Exterior' },
  { label: 'Left Exterior', value: 'Left Exterior' },
  { label: 'Right Exterior', value: 'Right Exterior' },
  { label: 'Electrical Room', value: 'Electrical Room' },
  { label: 'Riser Room', value: 'Riser Room' },
  { label: 'Meter Room', value: 'Meter Room' },
  { label: 'Sprinkler Room', value: 'Sprinkler Room' },
  { label: 'Utility Room', value: 'Utility Room' },
  { label: 'East Side of Property', value: 'East Side of Property' },
  { label: 'West Side of Property', value: 'West Side of Property' },
  { label: 'North Side of Property', value: 'North Side of Property' },
  { label: 'South Side of Property', value: 'South Side of Property' },
  { label: 'Northwest Corner', value: 'Northwest Corner' },
  { label: 'Southwest Corner', value: 'Southwest Corner' },
  { label: 'Northeast Corner', value: 'Northeast Corner' },
  { label: 'Southeast Corner', value: 'Southeast Corner' },
  { label: 'Pavilion', value: 'Pavilion' },
  { label: 'Alleyway', value: 'Alleyway' },
  { label: 'Grassy Area', value: 'Grassy Area' },
  { label: 'Meter Vault', value: 'Meter Vault' },
  { label: 'Hotbox', value: 'Hotbox' },
  { label: 'Parking Lot', value: 'Parking Lot' },
  { label: 'Sidewalk', value: 'Sidewalk' },
  { label: 'Street', value: 'Street' },
  { label: 'Parking Garage', value: 'Parking Garage' },
  { label: 'Roof', value: 'Roof' },
  { label: 'Basement', value: 'Basement' },
  { label: 'Ceiling', value: 'Ceiling' },
  { label: 'Restroom', value: 'Restroom' },
  { label: 'Restroom Ceiling', value: 'Restroom Ceiling' },
  { label: 'Closet', value: 'Closet' },
  { label: 'Kitchen', value: 'Kitchen' },
  { label: 'Office', value: 'Office' },
  { label: 'Warehouse', value: 'Warehouse' },
  { label: 'Maintenance Room', value: 'Maintenance Room' },
  { label: 'Mechanical Room', value: 'Mechanical Room' },
  { label: 'Inside the Space', value: 'Inside the Space' },
  { label: 'Inside Next Door Space', value: 'Inside Next Door Space' },
  { label: 'Recieving', value: 'Recieving' },
  { label: 'Inaccessible', value: 'Inaccessible' },
  { label: 'Other', value: 'Other' },
  { label: 'NA', value: 'NA' }
]

export default {
  basic_info: {
    separate_rpm_renders: {
      label: t('assetSchema.separate_rpm_renders.label'),
      placeholder: '',
      type: 'boolean',
      width: '100%'
    },
    virtual_tour_link: {
      label: t('assetSchema.virtual_tour_link.label'),
      placeholder: t('assetSchema.virtual_tour_link.placeholder'),
      type: "text",
      validation: /^(http|https):\/\/[^ "]+$/
    },
    actual_sq_ft: {
      label: t('assetSchema.actual_sq_ft.label'),
      publicLabel: t('assetSchema.actual_sq_ft.publicLabel'),
      placeholder: t('assetSchema.actual_sq_ft.placeholder'),
      type: "number",
      required: true,
      enabled: true,
      surveyed: true,
      visible: true,
      photosEnabled: false,
      viewModeRenderOptions: {
        append: "'"
      }
    },
    overall_actual_sq_ft: {
      label: t('assetSchema.overall_actual_sq_ft.label'),
      publicLabel: t('assetSchema.overall_actual_sq_ft.publicLabel'),
      placeholder: t('assetSchema.overall_actual_sq_ft.placeholder'),
      type: "number",
      required: false,
      enabled: true,
      visible: true,
      photosEnabled: false
    },
    client_provided_sq_ft: {
      label: t('assetSchema.client_provided_sq_ft.label'),
      placeholder: t('assetSchema.client_provided_sq_ft.placeholder'),
      required: true,
      enabled: true,
      surveyed: true,
      visible: true,
      type: "number"
    },
    has_stepdown_transformer: {
      label: t('assetSchema.has_stepdown_transformer.label'),
      placeholder: '',
      enabled: false,
      required: false,
      visible: false,
      photosEnabled: false,
      type: 'boolean'
    },
    tear_sheet: {
      label: t('assetSchema.tear_sheet.label'),
      placeholder: '',
      type: 'boolean',
      enabled: false,
      required: false,
      visible: false,
      photosEnabled: false
    },
    size: {
      label: t('assetSchema.size.label'),
      placeholder: intl.formatNumber(142128),
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      viewModeRenderOptions: {
        append: "'"
      }
    },
    office_area: {
      label: t('assetSchema.office_area'),
      placeholder: '6',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    mezannine_area: {
      label: t('assetSchema.mezannine_area'),
      placeholder: '',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    year_built: {
      label: t('assetSchema.year_built'),
      placeholder: '2001',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    site_size: {
      label: t('assetSchema.site_size.label'),
      placeholder: intl.formatNumber(9.86),
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    tax_pin: {
      label: t('assetSchema.tax_pin.label'),
      placeholder: '19-04-251-021',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      type: 'number'
    },
    zoning: {
      label: t('assetSchema.zoning'),
      type: 'text',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    measured_width_of_space: {
      label: t('assetSchema.measured_width_of_space.label'),
      publicLabel: t('assetSchema.measured_width_of_space.publicLabel'),
      placeholder: t('assetSchema.measured_width_of_space.placeholder'),
      type: "measurement",
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    measured_depth_of_space: {
      label: t('assetSchema.measured_depth_of_space.label'),
      placeholder: t('assetSchema.measured_depth_of_space.placeholder'),
      type: "measurement",
      visible: true,
      enabled: true,
      surveyed: true,
      required: true,
      photosEnabled: false
    },
    total_depth_of_space: {
      label: t('assetSchema.total_depth_of_space.label'),
      publicLabel: t('assetSchema.total_depth_of_space.publicLabel'),
      placeholder: t('assetSchema.total_depth_of_space.placeholder'),
      type: "measurement",
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    joist_direction: {
      label: t('assetSchema.joist_direction.label'),
      placeholder: t('assetSchema.joist_direction.placeholder'),
      type: 'select',
      isMulti: false,
      required: true,
      enabled: true,
      visible: true,
      surveyed: true,
      photosEnabled: false,
      options: [
        { label: t('assetSchema.joist_direction.front_to_back'), value: 'Front to Back' },
        { label: t('assetSchema.joist_direction.left_to_right'), value: 'Left to Right' },
        { label: t('assetSchema.joist_direction.other'), value: 'Other Direction - See Floor Plan' },
        { label: 'N/A', value: 'NA' }
      ]
    },
    storefront_slope_measurement: {
      label: t('assetSchema.storefront_slope_measurement.label'),
      placeholder: t('assetSchema.storefront_slope_measurement.placeholder'),
      type: "measurement",
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    storefront_slope_direction: {
      label: t('assetSchema.storefront_slope_direction.label'),
      placeholder: t('assetSchema.storefront_slope_direction.placeholder'),
      type: 'select',
      isMulti: true,
      options: [
        { label: 'Left', value: 'Left' },
        { label: 'Right', value: 'Right' },
        { label: 'NA', value: 'NA' }
      ],
      enabled: false,
      required: false,
      visible: false,
      photosEnabled: false
    },
    changes_in_demising_wall_thickness: {
      label: t('assetSchema.changes_in_demising_wall_thickness.label'),
      type: "boolean",
      placeholder: '',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    thermostat_count: {
      label: t('assetSchema.thermostat_count.label'),
      placeholder: '0',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    phone_board_count: {
      label: t('assetSchema.phone_board_count.label'),
      placeholder: '0',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    cleanout_count: {
      label: t('assetSchema.cleanout_count.label'),
      placeholder: '0',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    cleanout_location: {
      label: t('assetSchema.cleanout_location.label'),
      placeholder: '',
      type: 'select',
      isMulti: true,
      options: id360LocationOptions,
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    pad_mounted_transformer_count: {
      label: t('assetSchema.pad_mounted_transformer_count.label'),
      placeholder: '0',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    pad_mounted_transformer_location: {
      label: t('assetSchema.pad_mounted_transformer_location.label'),
      placeholder: '',
      type: 'select',
      isMulti: true,
      options: rpmLocationOptions,
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    riser_room_scanned_captured: {
      label: t('assetSchema.riser_room_scanned_captured.label'),
      type: "boolean",
      placeholder: '',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    hazardous_materials: {
      label: t('assetSchema.hazardous_materials.label'),
      type: "boolean",
      placeholder: '',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      width: '100%'
    },
    loading_dock: {
      label: t('assetSchema.loading_dock.label'),
      type: "boolean",
      placeholder: '',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    outer_unit_corner_to_outer_block_corner: {
      label: t('assetSchema.headers.outer_unit_corner_to_outer_block_corner'),
      left: {
        label: t('assetSchema.left'),
        placeholder: `13' 2"`,
        type: "measurement",
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      right: {
        label: t('assetSchema.right'),
        placeholder: `10' 11"`,
        type: "measurement",
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      }
    },
    height_from_floor_to_bottom_of_girder_kite: {
      label: t('assetSchema.headers.height_from_floor_to_bottom_of_girder_kite'),
      left_front: {
        label: t('assetSchema.left_or_front'),
        placeholder: `15' 6"`,
        type: "measurement",
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      right_rear: {
        label: t('assetSchema.right_or_rear'),
        placeholder: `13' 7"`,
        type: "measurement",
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      }
    },
    thickness: {
      label: t('assetSchema.headers.thickness'),
      front_wall: {
        label: t('assetSchema.thickness.front_wall'),
        placeholder: '5"',
        type: "measurement",
        required: true,
        visible: true,
        enabled: true,
        surveyed: true,
        photosEnabled: false
      },
      rear_wall: {
        label: t('assetSchema.thickness.rear_wall'),
        placeholder: '1"',
        type: "measurement",
        enabled: true,
        surveyed: true,
        required: true,
        visible: true,
        photosEnabled: false
      },
      left_wall: {
        label: t('assetSchema.thickness.left_wall'),
        placeholder: '4"',
        type: "measurement",
        enabled: true,
        surveyed: true,
        required: true,
        visible: true,
        photosEnabled: false
      },
      right_wall: {
        label: t('assetSchema.thickness.right_wall'),
        placeholder: '8"',
        type: "measurement",
        enabled: true,
        surveyed: true,
        required: true,
        visible: true,
        photosEnabled: false
      }
    },
    unit_overview: {
      label: t('assetSchema.headers.unit_overview'),
      sales_area: {
        label: t('assetSchema.sales_area'),
        placeholder: "3672’",
        type: "number",
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false,
        viewModeRenderOptions: {
          append: "'"
        }
      },
      stock_room: {
        label: t('assetSchema.stock_room'),
        placeholder: "116’",
        type: "number",
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false,
        viewModeRenderOptions: {
          append: "'"
        }
      },
      exterior_doors: {
        label: t('assetSchema.exterior_doors'),
        placeholder: "5",
        type: "number",
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false,
        viewModeRenderOptions: {
          append: "'"
        }
      },
      other: {
        label: t('assetSchema.unit_overview.other'),
        placeholder: "1834’",
        type: "number",
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false,
        viewModeRenderOptions: {
          append: "'"
        }
      }
    },
    flooring_square_footage: {
      label: t('assetSchema.flooring_square_footage'),
      concrete: {
        label: t('assetSchema.concrete'),
        placeholder: "3672’",
        type: "number",
        required: false,
        enabled: true,
        surveyed: true,
        visible: true,
        photosEnabled: false,
        viewModeRenderOptions: {
          append: "'"
        }
      },
      tile: {
        label: t('assetSchema.tile'),
        placeholder: "116’",
        type: "number",
        required: false,
        enabled: true,
        surveyed: true,
        visible: true,
        photosEnabled: false,
        viewModeRenderOptions: {
          append: "'"
        }
      },
      other: {
        label: t('assetSchema.flooring.other'),
        placeholder: "1834’",
        type: "number",
        required: false,
        enabled: true,
        surveyed: true,
        visible: true,
        photosEnabled: false,
        viewModeRenderOptions: {
          append: "'",
          paren: 'basic_info.flooring_square_footage.type_of_other'
        }
      },
      carpet: {
        label: t('assetSchema.carpet'),
        placeholder: "3672’",
        type: "number",
        required: false,
        enabled: true,
        surveyed: true,
        visible: true,
        photosEnabled: false,
        viewModeRenderOptions: {
          append: "'"
        }
      },
      total: {
        label: t('assetSchema.flooring.total.label'),
        publicLabel: t('assetSchema.flooring.total.publicLabel'),
        placeholder: "4032’",
        type: "number",
        required: true,
        enabled: true,
        surveyed: true,
        visible: true,
        photosEnabled: false,
        viewModeRenderOptions: {
          append: "'"
        }
      },
      unit: {
        label: t('assetSchema.flooring.unit.label'),
        publicLabel: t('assetSchema.flooring.unit.publicLabel'),
        placeholder: "4128’",
        type: "number",
        required: true,
        enabled: true,
        surveyed: true,
        visible: true,
        photosEnabled: false,
        viewModeRenderOptions: {
          append: "'"
        }
      },
      type_of_other: {
        label: t('assetSchema.flooring.type_of_other.label'),
        placeholder: t('assetSchema.flooring.type_of_other.placeholder'),
        enabled: true,
        required: false,
        surveyed: true,
        visible: true,
        photosEnabled: false,
        type: "text"
      }
    },
    ceiling_information: {
      label: t('assetSchema.headers.ceiling_information'),
      height_from_floor_to_ceiling: {
        label: t('assetSchema.height_from_floor_to_ceiling'),
        front: {
          label: t('assetSchema.front'),
          placeholder: `10' 3"`,
          visible: true,
          enabled: true,
          surveyed: true,
          required: true,
          photosEnabled: false,
          type: "measurement"
        },
        back: {
          label: t('assetSchema.back'),
          placeholder: `9' 11"`,
          visible: true,
          enabled: true,
          surveyed: true,
          required: true,
          photosEnabled: false,
          type: "measurement"
        },
        center: {
          label: t('assetSchema.center'),
          placeholder: `7' 6"`,
          type: "measurement",
          required: false,
          enabled: false,
          visible: false,
          photosEnabled: false
        }
      },
      height_from_floor_to_bottom_of_deck: {
        label: t('assetSchema.height_from_floor_to_bottom_of_deck'),
        front: {
          label: t('assetSchema.front'),
          placeholder: `16' 4"`,
          enabled: true,
          surveyed: true,
          visible: true,
          required: true,
          photosEnabled: false,
          type: "measurement"
        },
        back: {
          label: t('assetSchema.back'),
          placeholder: `15' 4"`,
          enabled: true,
          surveyed: true,
          visible: true,
          required: true,
          photosEnabled: false,
          type: "measurement"
        },
        center: {
          label: t('assetSchema.center'),
          placeholder: `14' 7"`,
          type: "measurement",
          required: false,
          enabled: false,
          visible: false,
          photosEnabled: false
        }
      },
      height_from_floor_to_bottom_of_joist: {
        label: t('assetSchema.height_from_floor_to_bottom_of_joist'),
        front: {
          label: t('assetSchema.front'),
          placeholder: `15' 8"`,
          enabled: true,
          surveyed: true,
          visible: true,
          required: true,
          photosEnabled: false,
          type: "measurement"
        },
        back: {
          label: t('assetSchema.back'),
          placeholder: `14' 8"`,
          enabled: true,
          surveyed: true,
          visible: true,
          required: true,
          photosEnabled: false,
          type: "measurement"
        },
        center: {
          label: t('assetSchema.center'),
          placeholder: `16' 2"`,
          type: "measurement",
          required: false,
          enabled: false,
          visible: false,
          photosEnabled: false
        }
      },
      clear_height: {
        label: t('assetSchema.clear_height'),
        type: 'measurement',
        required: false,
        enabled: false,
        surveyed: false,
        softRequired: false,
        visible: false,
        photosEnabled: false
      },
      height_from_floor_to_bottom_of_girder: {
        label: t('assetSchema.height_from_floor_to_bottom_of_girder'),
        right_rear: {
          label: t('assetSchema.right_rear'),
          type: 'measurement',
          enabled: true,
          required: false,
          visible: true,
          photosEnabled: false,
          surveyed: true
        },
        right_front: {
          label: t('assetSchema.right_front'),
          type: 'measurement',
          enabled: true,
          required: false,
          visible: true,
          photosEnabled: false,
          surveyed: true
        },
        left_front: {
          label: t('assetSchema.left_front'),
          type: 'measurement',
          enabled: true,
          required: false,
          visible: true,
          photosEnabled: false,
          surveyed: true
        },
        left_rear: {
          label: t('assetSchema.left_rear'),
          type: 'measurement',
          enabled: true,
          required: false,
          visible: true,
          photosEnabled: false,
          surveyed: true
        },
        middle: {
          label: t('assetSchema.middle'),
          type: 'measurement',
          enabled: true,
          required: false,
          visible: true,
          photosEnabled: false,
          surveyed: true
        }
      },
      clear_ceiling_height: {
        label: t('assetSchema.clear_ceiling_height'),
        type: 'measurement',
        enabled: true,
        surveyed: true,
        required: true,
        visible: true,
        photosEnabled: false
      },
      number_of_acoustical_tiles: {
        label: t('assetSchema.number_of_acoustical_tiles'),
        placeholder: '42',
        type: 'number',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      clear_height_floor_to_deck: {
        label: t('assetSchema.clear_height_floor_to_deck'),
        type: 'measurement',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      clear_height_floor_front_column: {
        label: t('assetSchema.clear_height_floor_front_column'),
        type: 'measurement',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      clear_height_floor_mid_column: {
        label: t('assetSchema.clear_height_floor_mid_column'),
        type: 'measurement',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      clear_height_floor_rear_column: {
        label: t('assetSchema.clear_height_floor_rear_column'),
        type: 'measurement',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      clear_height_floor_to_lowest_obstruction: {
        label: t('assetSchema.clear_height_floor_to_lowest_obstruction'),
        type: 'measurement',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      }
    },
    construction_overview: {
      label: t('assetSchema.headers.construction_overview'),
      structure: {
        label: t('assetSchema.structure.label'),
        placeholder: t('assetSchema.structure.placeholder'),
        type: 'text',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      roof_type: {
        label: t('assetSchema.roof.label'),
        placeholder: t('assetSchema.roof.placeholder'),
        type: 'text',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      roof_warranty_expiration: {
        label: t('assetSchema.roof_warranty_expiration.label'),
        placeholder: intl.formatDate('2020-12-30', { year: 'numeric', month: 'numeric', day: 'numeric' }),
        type: 'date',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      sprinkler_system: {
        label: t('assetSchema.sprinkler_system.label'),
        placeholder: t('assetSchema.sprinkler_system.placeholder'),
        type: 'select',
        isMulti: true,
        options: [
          { label: 'Dry', value: 'Dry' },
          { label: 'Wet', value: 'Wet' },
          { label: 'NA', value: 'NA' }
        ],
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      sprinkler_head_type: {
        label: t('assetSchema.sprinkler_head_type.label'),
        type: 'text',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      warehouse_lighting_type: {
        label: t('assetSchema.warehouse_lighting_type.label'),
        placeholder: t('assetSchema.warehouse_lighting_type.placeholder'),
        type: 'select',
        isMulti: true,
        options: [
          { label: 'Fluorescent', value: 'Fluorescent' },
          { label: 'Halogen', value: 'Halogen' },
          { label: 'High-Pressure Sodium', value: 'High-Pressure Sodium' },
          { label: 'Incandescent', value: 'Incandescent' },
          { label: 'LED', value: 'LED' },
          { label: 'Metal Halide', value: 'Metal Halide' },
          { label: 'NA', value: 'NA' }
        ],
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      warehouse_sprinkler_head_type: {
        label: t('assetSchema.warehouse_sprinkler_head_type.label'),
        type: 'select',
        isMulti: true,
        options: [
          { label: 'Concealed', value: 'Concealed' },
          { label: 'Pendent', value: 'Pendent' },
          { label: 'Sidewall', value: 'Sidewall' },
          { label: 'Upright', value: 'Upright' },
          { label: 'NA', value: 'NA' }
        ],
        visible: false,
        enabled: false,
        required: false,
        photosEnabled: false
      },
      office_sprinkler_head_type: {
        label: t('assetSchema.office_sprinkler_head_type.label'),
        type: 'select',
        isMulti: true,
        options: [
          { label: 'Concealed', value: 'Concealed' },
          { label: 'Pendent', value: 'Pendent' },
          { label: 'Sidewall', value: 'Sidewall' },
          { label: 'Upright', value: 'Upright' },
          { label: 'NA', value: 'NA' }
        ],
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      office_lighting_type: {
        label: t('assetSchema.office_lighting_type.label'),
        type: 'select',
        isMulti: true,
        options: [
          { label: 'Fluorescent', value: 'Fluorescent' },
          { label: 'Halogen', value: 'Halogen' },
          { label: 'High-Pressure Sodium', value: 'High-Pressure Sodium' },
          { label: 'Incandescent', value: 'Incandescent' },
          { label: 'LED', value: 'LED' },
          { label: 'Metal Halide', value: 'Metal Halide' },
          { label: 'NA', value: 'NA' }
        ],
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      }
    },
    property_features: {
      label: t('assetSchema.headers.property_features'),
      building_dimensions: {
        label: t('assetSchema.space_dimensions'),
        type: 'text',
        placeholder: "220' x 672'",
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      space_dimensions_width: {
        label: t('assetSchema.space_dimensions_width'),
        type: 'measurement',
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      space_dimensions_length: {
        label: t('assetSchema.space_dimensions_length'),
        type: 'measurement',
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      column_bay_spacing: {
        label: t('assetSchema.column_bay_spacing'),
        type: 'measurement',
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      column_bay_spacing_depth: {
        label: t('assetSchema.column_bay_spacing_depth'),
        type: 'measurement',
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      speed_bays: {
        label: t('assetSchema.speed_bays'),
        type: 'measurement',
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      truck_court_depth: {
        label: t('assetSchema.truck_court_depth'),
        type: 'measurement',
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      truck_apron: {
        label: t('assetSchema.truck_apron'),
        type: 'measurement',
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      loading: {
        label: t('assetSchema.loading.label'),
        type: 'select',
        isMulti: true,
        options: [
          { label: 'Cross', value: 'Cross' },
          { label: 'Front', value: 'Front' },
          { label: 'Rear', value: 'Rear' },
          { label: 'Side', value: 'Side' },
          { label: 'All Sides', value: 'All Sides' },
          { label: 'NA', value: 'NA' }
        ],
        placeholder: t('assetSchema.loading.placeholder'),
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      floor_load: {
        label: t('assetSchema.floor_load'),
        type: 'number',
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      num_of_trailer_parking_spots: {
        label: t('assetSchema.num_of_trailer_parking_spots'),
        type: 'number',
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      dock_doors: {
        label: t('assetSchema.dock_doors'),
        type: 'number',
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      drive_in_doors: {
        label: t('assetSchema.drive_in_doors'),
        type: 'number',
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      railway_dock_doors: {
        label: t('assetSchema.railway_dock_doors'),
        type: 'number',
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      car_parking: {
        label: t('assetSchema.car_parking'),
        type: 'number',
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      hvac: {
        label: t('assetSchema.hvac'),
        type: 'text',
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      utility_submetered: {
        label: t('assetSchema.utility_submetered'),
        type: 'text',
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      interior_dock_leveler_type: {
        label: t('assetSchema.headers.interior_dock_leveler_type'),
        type: 'select',
        options: [
          { label: 'Mechanical', value: 'Mechanical' },
          { label: 'Hydraulic', value: 'Hydraulic' },
          { label: 'NA', value: 'NA' }
        ],
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      interior_dock_leveler_width: {
        label: t('assetSchema.headers.interior_dock_leveler_width'),
        type: 'measurement',
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      interior_dock_leveler_height: {
        label: t('assetSchema.headers.interior_dock_leveler_height'),
        type: 'measurement',
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      dock_leveler_length: {
        label: t('assetSchema.headers.dock_leveler_length'),
        type: 'measurement',
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      power: {
        label: t('assetSchema.power.label'),
        type: 'text',
        placeholder: t('assetSchema.power.label'),
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      storefront_width: {
        label: t('assetSchema.headers.storefront_width'),
        type: 'measurement',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      storefront_features: {
        label: t('assetSchema.headers.storefront_features'),
        type: 'select',
        isMulti: true,
        options: [
          { label: t('assetSchema.walkway'), value: 'Walkway' },
          { label: t('assetSchema.trash_cans'), value: 'Trash Cans' },
          { label: t('assetSchema.ash_trays'), value: 'Ash Trays' },
          { label: t('assetSchema.handicap_parking'), value: 'Handicap Parking' },
          { label: t('assetSchema.columns'), value: 'Column(s)' },
          { label: t('assetSchema.crosswalk'), value: 'Crosswalk' },
          { label: t('assetSchema.canopy'), value: 'Canopy' },
          { label: t('assetSchema.trees'), value: 'Tree(s)' },
          { label: t('assetSchema.bushes'), value: 'Bushes' },
          { label: t('assetSchema.steps'), value: 'Steps' },
          { label: t('assetSchema.ramps'), value: 'Ramps' },
          { label: t('assetSchema.handicap_signs'), value: 'Handicap Signs' },
          { label: t('assetSchema.stop_signs'), value: 'Stop Signs' },
          { label: t('assetSchema.tenant_signs'), value: 'Tenant Signs' },
          { label: t('assetSchema.other_affixed_signage'), value: 'Other Affixed Signage' },
          { label: t('assetSchema.railings'), value: 'Railing' },
          { label: t('assetSchema.bollards'), value: 'Bollards' },
          { label: t('assetSchema.grass'), value: 'Grass' },
          { label: t('assetSchema.garden'), value: 'Garden' },
          { label: t('assetSchema.fire_hydrant'), value: 'Fire Hydrant' },
          { label: t('assetSchema.planters'), value: 'Planters' },
          { label: t('assetSchema.dirt'), value: 'Dirt' },
          { label: t('term.other'), value: 'Other' },
          { label: t('assetSchema.not_available'), value: 'NA' }
        ],
        visible: false,
        enabled: false,
        required: false,
        photosEnabled: false
      },
      damaged_stained_missing_acoustical_tiles: {
        label: t('assetSchema.headers.damaged_stained_missing_acoustical_tiles'),
        type: 'number',
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      ceiling_types: {
        label: t('assetSchema.headers.ceiling_types'),
        type: 'select',
        isMulti: true,
        options: [
          { label: t('assetSchema.open_ceiling'), value: 'Open Ceiling' },
          { label: t('assetSchema.acoustic_tile'), value: 'Acoustic Tile' },
          { label: t('assetSchema.drywall'), value: 'Drywall' },
          { label: t('assetSchema.wood'), value: 'Wood' },
          { label: t('assetSchema.metal'), value: 'Metal' },
          { label: t('assetSchema.concrete_type'), value: 'Concrete' },
          { label: t('assetSchema.stucco'), value: 'Stucco' },
          { label: t('term.other'), value: 'Other' },
          { label: t('assetSchema.inconclusive'), value: 'Inconclusive' },
          { label: t('assetSchema.inaccessible'), value: 'Inaccessible' }
        ],
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      wall_types: {
        label: t('assetSchema.headers.wall_types'),
        type: 'select',
        isMulti: true,
        options: [
          { label: t('assetSchema.drywall'), value: 'Drywall' },
          { label: t('assetSchema.glass'), value: 'Glass' },
          { label: t('assetSchema.wood'), value: 'Wood' },
          { label: t('assetSchema.stone'), value: 'Stone' },
          { label: t('assetSchema.concrete_type'), value: 'Concrete' },
          { label: t('assetSchema.vinyl'), value: 'Vinyl' },
          { label: t('assetSchema.stucco'), value: 'Stucco' },
          { label: t('assetSchema.metal'), value: 'Metal' },
          { label: t('assetSchema.pvc'), value: 'PVC' },
          { label: t('assetSchema.tile_type'), value: 'Tile' },
          { label: t('assetSchema.brick'), value: 'Brick' },
          { label: t('assetSchema.fiber_reinforced_plastic'), value: 'Fiber Reinforced Plastic' },
          { label: t('term.other'), value: 'Other' },
          { label: t('assetSchema.open_stud'), value: 'Open Stud' },
          { label: t('assetSchema.inconclusive'), value: 'Inconclusive' },
          { label: t('assetSchema.inaccessible'), value: 'Inaccessible' }
        ],
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      exterior_door_count: {
        label: t('assetSchema.headers.exterior_door_count'),
        type: 'number',
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      exterior_door_dimensions: {
        label: t('assetSchema.headers.exterior_door_dimensions'),
        type: 'select',
        isMulti: true,
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false,
        options: [
          { label: `3'0" W x 7'0" H`, value: `3'0" W x 7'0" H` },
          { label: `3'0" W x 6'0" H`, value: `3'0" W x 6'0" H` },
          { label: `3'0" W x 6'11" H`, value: `3'0" W x 6'11" H` },
          { label: `2'8" W x 6'11" H`, value: `2'8" W x 6'11" H` },
          { label: `2'8" W x 7'0" H`, value: `2'8" W x 7'0" H` },
          { label: `2'11" W x 6'0" H`, value: `2'11" W x 6'0" H` },
          { label: `2'11" W x 7'0" H`, value: `2'11" W x 7'0" H` },
          { label: `2'11" W x 6'11" H`, value: `2'11" W x 6'11" H` },
          { label: `3'6" W x 7'0" H`, value: `3'6" W x 7'0" H` },
          { label: `3'6" W x 8'0" H`, value: `3'6" W x 8'0" H` },
          { label: `3'10" W x 7'0" H`, value: `3'10" W x 7'0" H` },
          { label: `3'11" W x 7'0" H`, value: `3'11" W x 7'0" H` },
          { label: `3'10" W x 6'11" H`, value: `3'10" W x 6'11" H` },
          { label: `3'11" W x 6'11" H`, value: `3'11" W x 6'11" H` },
          { label: `3'10" W x 6'10" H`, value: `3'10" W x 6'10" H` },
          { label: `3'11" W x 6'10" H`, value: `3'11" W x 6'10" H` },
          { label: `3'0" W x 8'0" H`, value: `3'0" W x 8'0" H` },
          { label: `4'0" W x 7'0" H`, value: `4'0" W x 7'0" H` },
          { label: `4'0" W x 6'11" H`, value: `4'0" W x 6'11" H` },
          { label: `4'0" W x 6'10" H`, value: `4'0" W x 6'10" H` },
          { label: `4'0" W x 8'0" H`, value: `4'0" W x 8'0" H` },
          { label: `4'11" W x 7'0" H`, value: `4'11" W x 7'0" H` },
          { label: `4'11" W x 8'0" H`, value: `4'11" W x 8'0" H` },
          { label: `5'0" W x 7'0" H`, value: `5'0" W x 7'0" H` },
          { label: `5'0" W x 8'0" H`, value: `5'0" W x 8'0" H` },
          { label: `5'0" W x 6'11" H`, value: `5'0" W x 6'11" H` },
          { label: `5'0" W x 7'11" H`, value: `5'0" W x 7'11" H` },
          { label: `5'11" W x 7'0" H`, value: `5'11" W x 7'0" H` },
          { label: `5'11" W x 8'0" H`, value: `5'11" W x 8'0" H` },
          { label: `6'0" W x 7'0" H`, value: `6'0" W x 7'0" H` },
          { label: `6'0" W x 8'0" H`, value: `6'0" W x 8'0" H` },
          { label: `6'0" W x 6'11" H`, value: `6'0" W x 6'11" H` },
          { label: `6'0" W x 7'11" H`, value: `6'0" W x 7'11" H` },
          { label: t('term.other'), value: `Other` }
        ]
      },
      exterior_door_locations: {
        label: t('assetSchema.headers.exterior_door_locations'),
        type: 'select',
        isMulti: true,
        options: [
          { label: t('assetSchema.front'), value: 'Front' },
          { label: t('assetSchema.left_side'), value: 'Left Side' },
          { label: t('assetSchema.right_side'), value: 'Right Side' },
          { label: t('assetSchema.rear'), value: 'Rear' },
          { label: t('assetSchema.all_sides'), value: 'All Sides' }
        ],
        enabled: false,
        required: false,
        visible: false,
        photosEnabled: false
      },
      light_fixture_count: {
        label: t('assetSchema.headers.light_fixture_count'),
        placeholder: '0',
        type: 'number',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      type_of_fixture: {
        label: t('assetSchema.headers.type_of_fixture'),
        type: 'select',
        isMulti: true,
        options: [
          { label: t('assetSchema.options.encased'), value: 'Encased' },
          { label: t('assetSchema.options.suspended'), value: 'Suspended' },
          { label: t('assetSchema.options.recessed'), value: 'Recessed' },
          { label: t('assetSchema.options.flush_mount'), value: 'Flush Mount' },
          { label: t('assetSchema.options.track'), value: 'Track' },
          { label: t('assetSchema.options.sconce'), value: 'Sconce' },
          { label: t('assetSchema.options.strip'), value: 'Strip' },
          { label: t('assetSchema.options.NA'), value: 'NA' }
        ],
        visible: false,
        enabled: false,
        photosEnabled: false,
        required: false
      },
      type_of_lighting: {
        label: t('assetSchema.headers.type_of_lighting'),
        type: 'select',
        isMulti: true,
        options: [
          { label: t('assetSchema.options.flourescent'), value: 'Flourescent' },
          { label: t('assetSchema.options.led'), value: 'LED' },
          { label: t('assetSchema.options.halogen'), value: 'Halogen' },
          { label: t('assetSchema.options.metal_hallide'), value: 'Metal Hallide' },
          { label: t('assetSchema.options.hps'), value: 'HPS (Hight Pressure Sodium)' },
          { label: t('assetSchema.options.incandescent'), value: 'Incandescent' },
          { label: t('assetSchema.options.NA'), value: 'NA' }
        ],
        visible: false,
        enabled: false,
        photosEnabled: false,
        required: false
      },
      access_interior_area: {
        label: t('assetSchema.access_interior_area.label'),
        type: 'boolean',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false,
        viewModeRenderOptions: {
          options: { fullLength: true }
        }
      },
      floor_drain_count: {
        label: t('assetSchema.floor_drain_count.label'),
        placeholder: '0',
        type: 'number',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      floor_drain_location: {
        label: t('assetSchema.floor_drain_location.label'),
        placeholder: '',
        type: 'select',
        isMulti: true,
        options: id360LocationOptions,
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      exterior_transformer: {
        label: t('assetSchema.exterior_transformer.label'),
        type: 'boolean',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      meter_room_space: {
        label: t('assetSchema.meter_room_space.label'),
        type: 'boolean',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      exterior_access_rooms: {
        label: t('assetSchema.exterior_access_rooms.label'),
        type: 'boolean',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      exterior_partition_extrusion: {
        label: t('assetSchema.exterior_partition_extrusion.label'),
        type: 'boolean',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      },
      hydraulic_sprinkler: {
        label: t('assetSchema.hydraulic_sprinkler.label'),
        type: 'boolean',
        required: false,
        enabled: false,
        visible: false,
        photosEnabled: false
      }
    },
    electric_meter_distance: {
      label: t('assetSchema.electric_meter_distance'),
      placeholder: '23',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      viewModeRenderOptions: {
        options: { fullLength: true }
      }
    },
    gas_meter_distance: {
      label: t('assetSchema.gas_meter_distance'),
      placeholder: '24',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      viewModeRenderOptions: {
        options: { fullLength: true }
      }
    },
    water_meter_distance: {
      label: t('assetSchema.water_meter_distance'),
      placeholder: '32',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      viewModeRenderOptions: {
        options: { fullLength: true }
      }
    },
    transformer_distance: {
      label: t('assetSchema.transformer_distance'),
      placeholder: '33',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      viewModeRenderOptions: {
        options: { fullLength: true }
      }
    },
    sewer_cleanout_distance: {
      label: t('assetSchema.sewer_cleanout_distance'),
      placeholder: '42',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      viewModeRenderOptions: {
        options: { fullLength: true }
      }
    },
    utility_room_distance: {
      label: t('assetSchema.utility_room_distance'),
      placeholder: '47',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      viewModeRenderOptions: {
        options: { fullLength: true }
      }
    },
    DMARC_distance: {
      label: t('assetSchema.DMARC_distance'),
      placeholder: '46',
      type: 'number',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      viewModeRenderOptions: {
        options: { fullLength: true }
      }
    },
    phone_board_location: {
      label: t('assetSchema.phone_board_location'),
      placeholder: '',
      type: 'select',
      isMulti: true,
      options: id360LocationOptions,
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    mop_sink_location: {
      label: t('assetSchema.mop_sink_location'),
      placeholder: '',
      type: 'select',
      isMulti: true,
      options: id360LocationOptions,
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    mop_sink_count: {
      label: t('assetSchema.mop_sink_count'),
      placeholder: '',
      type: 'text',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    sanitary_sewer_location: {
      label: t('assetSchema.sanitary_sewer_location'),
      placeholder: '',
      type: 'select',
      isMulti: true,
      options: id360LocationOptions,
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    sanitary_sewer_count: {
      label: t('assetSchema.sanitary_sewer_count'),
      placeholder: '',
      type: 'text',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    thermostat_location: {
      label: t('assetSchema.thermostat_location.label'),
      placeholder: '',
      type: 'select',
      isMulti: true,
      options: id360LocationOptions,
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    cooler_manufacturer: {
      label: 'Cooler Manufacturer',
      placeholder: '',
      type: 'text',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    are_demising_walls_full_height: {
      label: t('assetSchema.are_demising_walls_full_height'),
      placeholder: '',
      type: 'boolean',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      viewModeRenderOptions: {
        options: { fullLength: true }
      },
      width: '100%'
    },
    which_demising_wall_changes: {
      label: t('assetSchema.which_demising_wall_changes.label'),
      placeholder: t('assetSchema.which_demising_wall_changes.placeholder'),
      type: 'select',
      isMulti: true,
      options: [
        { label: 'Left', value: 'Left' },
        { label: 'Right', value: 'Right' },
        { label: 'Front', value: 'Front' },
        { label: 'Rear', value: 'Rear' },
        { label: 'NA', value: 'NA' }
      ],
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    difference_demising_wall_thickness: {
      label: t('assetSchema.difference_demising_wall_thickness.label'),
      placeholder: t('assetSchema.difference_demising_wall_thickness.placeholder'),
      type: 'text',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false
    },
    are_interior_walls_full_height: {
      label: t('assetSchema.are_interior_walls_full_height'),
      placeholder: '',
      type: 'boolean',
      required: false,
      enabled: false,
      visible: false,
      photosEnabled: false,
      viewModeRenderOptions: {
        options: { fullLength: true }
      },
      width: '100%'
    },
    lockbox_used_to_access_the_space: {
      label: t('assetSchema.lockbox_used_to_access_the_space'),
      placeholder: '',
      type: 'boolean',
      enabled: false,
      required: false,
      visible: false,
      photosEnabled: false
    },
    exterior_ladder_used_to_access_the_roof: {
      label: t('assetSchema.exterior_ladder_used_to_access_the_roof'),
      placeholder: '',
      type: 'boolean',
      enabled: false,
      required: false,
      visible: false,
      photosEnabled: false
    },
    roof_too_unsafe_to_access: {
      label: t('assetSchema.roof_too_unsafe_to_access'),
      placeholder: '',
      type: 'boolean',
      enabled: false,
      required: false,
      visible: false,
      photosEnabled: false
    },
    roof_hatch_used_to_access_the_roof: {
      label: t('assetSchema.roof_hatch_used_to_access_the_roof'),
      placeholder: '',
      type: 'boolean',
      enabled: false,
      required: false,
      visible: false,
      photosEnabled: false
    },
    exterior_wall_photograph: {
      label: t('assetSchema.exterior_wall_photograph.label'),
      placeholder: '',
      type: 'boolean',
      enabled: false,
      required: false,
      visible: false,
      photosEnabled: false
    },
    storefront_scan_width: {
      label: t('assetSchema.storefront_scan_width.label'),
      placeholder: '',
      type: 'boolean',
      enabled: false,
      required: false,
      visible: false,
      photosEnabled: false
    },
    roof_capture_hvac: {
      label: t('assetSchema.roof_capture_hvac.label'),
      placeholder: '',
      type: 'boolean',
      enabled: false,
      required: false,
      visible: false,
      photosEnabled: false
    },
    roof_plan_complete: {
      label: t('assetSchema.roof_plan_complete.label'),
      placeholder: '',
      type: 'boolean',
      enabled: false,
      required: false,
      visible: false,
      photosEnabled: false
    },
    projector_photograph: {
      label: t('assetSchema.projector_photograph.label'),
      placeholder: '',
      type: 'boolean',
      enabled: false,
      required: false,
      visible: false,
      photosEnabled: false
    },
    window_pane_type: {
      label: t('assetSchema.window_pane_type.label'),
      placeholder: t('assetSchema.window_pane_type.placeholder'),
      type: 'select',
      isMulti: true,
      options: [
        { label: t('assetSchema.single_pane'), value: 'Single Pane' },
        { label: t('assetSchema.double_pane'), value: 'Double Pane' },
        { label: t('assetSchema.triple_pane'), value: 'Triple Pane' },
        { label: 'NA', value: 'NA' }
      ],
      enabled: false,
      required: false,
      visible: false,
      photosEnabled: false
    },
    misc_notes: {
      label: t('assetSchema.misc_notes.label'),
      placeholder: t('assetSchema.misc_notes.placeholder'),
      type: "textarea",
      required: false,
      enabled: true,
      visible: true,
      photosEnabled: false,
      width: '100%'
    },
    integrations: {
      label: t('assetSchema.integrations'),
      integration_property_id: {
        label: t('assetSchema.integrations'),
        placeholder: '1337',
        type: 'text',
        required: false,
        enabled: false,
        visible: false
      },
      idp_record_id: {
        label: t('assetSchema.integrations.idp_record_id'),
        placeholder: '10000000',
        type: 'text',
        required: true,
        enabled: true
      }
    }
  }
}
